import { Fragment, useEffect, useState } from 'react';
import SellerSidebar from './SellerSidebar';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import {
  getSellerSingleOrder,
} from '../../actions/orderActions';
import { toast } from 'react-toastify';
import { clearError } from '../../slices/orderSlice';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faCartShopping,
  faFilter,
  faSearch,
  faDashboard,
  faList,
  faShoppingBag,
  faSort,
} from '@fortawesome/free-solid-svg-icons';
import { Dropdown } from 'react-bootstrap';
import Drawer from '@mui/material/Drawer';
import MetaData from '../layouts/MetaData';

export default function SellerOrderDetail() {
  const {
    orderDatail = [],
    error,
    orderDetail,
  } = useSelector(state => state.orderState);
  const { paymentInfo = {}, orderStatus } = orderDetail;
  const { id: orderId } = useParams();

  const dispatch = useDispatch();

  useEffect(() => {
    if (error) {
      toast(error, {
        type: 'error',
        onOpen: () => {
          dispatch(clearError());
        },
      });
      return;
    }

    dispatch(getSellerSingleOrder(orderId));
  }, [error, dispatch, orderId]);

  // Drawer
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);

  const toggleDrawer = () => {
    setIsDrawerOpen(!isDrawerOpen);
  };

  // Navbar
  const [isMobile, setIsMobile] = useState(window.innerWidth < 1000);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 1000);
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const formattedPaidDate = orderDatail?.paidAt
  ? new Date(orderDatail.paidAt).toLocaleDateString('en-IN')
  : null;

const formattedShippedDate = orderDatail?.shippedAt
  ? new Date(orderDatail.shippedAt).toLocaleDateString('en-IN')
  : null;

  return (
    <>
      <MetaData
        title={`Order #${orderDatail?.clocreOrderId || orderId} | GLOCRE Private Limited`}
      />
      <section className="seller-order-details-glc">
        <div className="row container-fluid">
          <div className="col-12 col-md-2">
            <SellerSidebar />
          </div>
          <div className="col-12 col-lg-10 col-md-12 pr-0">
            <Link to="/">
              <div className="mobile-logo">
                <img
                  src={require('../../images/procure-g-logo.png')}
                  alt="GLOCRE Logo"
                />
              </div>
            </Link>
            <div className="breadcrumbWrapperr">
              {/* Breadcrumbs & Menu Icon Row (For Mobile) */}
              {isMobile ? (
                <div className="row mobile-topbar">
                  <div className="col-10">
                    <ul className="breadcrumb breadcrumb2 mb-0">
                      <li>
                        <Link to="/admin/dashboard" style={{ color: '#fff' }}>
                          Dashboard
                        </Link>
                      </li>
                      <li>
                        <Link to="/seller/orders" style={{ color: '#fff' }}>
                          Order List
                        </Link>
                      </li>
                      <li>Update Order List</li>
                    </ul>
                  </div>
                  <div className="col-2 p-0 d-flex justify-content-center align-items-center">
                    <button className="fab" onClick={toggleDrawer}>
                      <FontAwesomeIcon icon={faList} />
                    </button>
                  </div>
                </div>
              ) : (
                <div className="row dash-navbar-big-glc small-sticky-navbar">
                  <div className="col-lg-3 col-md-12">
                    <ul className="breadcrumb breadcrumb2 mb-0">
                      <li>
                        <Link to="/admin/dashboard">Dashboard</Link>
                      </li>
                      <li>
                        <Link to="/seller/orders">Order List</Link>
                      </li>
                      <li>Update Order List</li>
                    </ul>
                  </div>
                  <div className="col-lg-7 col-md-6 d-flex justify-content-end align-items-end">
                    <div className="dash-cont-glc">
                      <div className="row">
                        <div className="topnav">
                          <div className="search-container">
                            <form className="d-flex">
                              <input
                                type="text"
                                placeholder="Search"
                                name="search"
                              />
                              <button type="submit">
                                <FontAwesomeIcon icon={faSearch} />
                              </button>
                            </form>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-lg-1 col-md-2 d-flex justify-content-center align-items-end">
                    <Dropdown className="d-inline">
                      <Dropdown.Toggle
                        variant="default"
                        id="dropdown-basic"
                        className="custom-filter-toggle"
                      >
                        <FontAwesomeIcon icon={faFilter} />
                      </Dropdown.Toggle>
                    </Dropdown>
                  </div>
                  {/* <div className="col-lg-1 col-md-2 dash-cont-glc">
                      <img src={avatar1} alt="Avatar" className="avatar" />
                    </div> */}
                </div>
              )}
              {/* Search, Filter & Avatar Row (For Mobile) */}
              {isMobile && (
                <div className="row mobile-bottombar">
                  <div className="col-9 col-md-10 pr-0">
                    <div className="search-container">
                      <form className="d-flex">
                        <input type="text" placeholder="Search" name="search" />
                        <button type="submit">
                          <FontAwesomeIcon icon={faSearch} />
                        </button>
                      </form>
                    </div>
                  </div>
                  <div className="col-3 col-md-2  d-flex justify-content-center align-items-end">
                    <Dropdown className="d-inline">
                      <Dropdown.Toggle
                        variant="default text-white"
                        id="dropdown-basic"
                        className="text-dark dropdown1 icon-list-filter-procureg"
                        style={{
                          backgroundImage: 'none',
                          border: 'none',
                          boxShadow: 'none',
                        }}
                      >
                        <FontAwesomeIcon icon={faFilter} />
                      </Dropdown.Toggle>
                    </Dropdown>
                  </div>
                </div>
              )}

              {/* Drawer Component */}
              <Drawer
                open={isDrawerOpen}
                onClose={toggleDrawer}
                direction="right"
                className="drawer"
              >
                <div className="drawer-header">
                  SELLER DASHBOARD
                  {/* <button className="drawer-close-btn" onClick={toggleDrawer}>&times;</button> */}
                </div>
                <div className="drawer-content">
                  <ul className="drawer-links">
                    <li>
                      <Link to="/seller/dashboard">
                        <FontAwesomeIcon icon={faDashboard} /> &nbsp;Dashboard
                      </Link>
                    </li>
                    <li>
                      <Link to="/seller/products">
                        <FontAwesomeIcon icon={faCartShopping} /> &nbsp;Product
                        List
                      </Link>
                    </li>
                    <li>
                      <Link to="/seller/products/create">
                        <FontAwesomeIcon icon={faShoppingBag} /> &nbsp;Create
                        Product
                      </Link>
                    </li>
                    <li>
                      <Link to="/seller/orders">
                        <FontAwesomeIcon icon={faSort} /> &nbsp;Order List
                      </Link>
                    </li>
                    <li>
                      <Link to="/seller/archive/product">
                        <FontAwesomeIcon icon={faSort} /> &nbsp;ArchivedProducts
                      </Link>
                    </li>
                  </ul>
                </div>
              </Drawer>
            </div>

            <h2
              className="text-xl sm:text-2xl font-semibold mt-12"
              style={{
                color: '#ffad63',
                marginTop: '40px',
                overflowWrap: 'anywhere', // Force word wrap
                wordBreak: 'break-word', // Fallback for older content
              }}
            >
              Order #{orderDatail?.clocreOrderId || orderId}
            </h2>

            <hr />

            <div className="mb-4 mt-3">
              <div className="row align-items-center">
                <div className="col-md-4 mb-2">
                  <h5
                    style={{
                      fontSize: '18px',
                      fontWeight: '600',
                      marginBottom: '6px',
                      color: '#2f2f2f',
                    }}
                  >
                    Order Status
                  </h5>

                  <span
                    style={{
                      color:
                        orderStatus === 'Delivered'
                          ? '#28a745'
                          : orderStatus === 'Shipped'
                            ? '#ffad63'
                            : '#dc3545',
                      fontWeight: '600',
                      fontSize: '15px',
                    }}
                  >
                    {orderDatail.orderStatus}
                  </span>
                </div>

                <div className="col-md-4 mb-2">
                  <h5
                    style={{
                      fontSize: '18px',
                      fontWeight: '600',
                      marginBottom: '6px',
                      color: '#2f2f2f',
                    }}
                  >
                    Payment
                  </h5>

                  <p
                    style={{
                      marginBottom: '4px',
                      fontSize: '15px',
                      fontWeight: '500',
                      color:
                        orderDatail?.paymentInfo?.status === 'paid'
                          ? '#28a745'
                          : '#dc3545',
                    }}
                  >
                    {orderDatail?.paymentInfo?.status === 'paid'
                      ? 'PAID'
                      : 'NOT PAID'}
                  </p>

                  {formattedPaidDate && (
                    <p
                      style={{
                        marginBottom: '0',
                        color: '#8c8c8c',
                        fontSize: '14px',
                      }}
                    >
                      Paid On: {formattedPaidDate}
                    </p>
                  )}
                </div>

                <div className="col-md-4 mb-2">
                  <h5
                    style={{
                      fontSize: '18px',
                      fontWeight: '600',
                      marginBottom: '6px',
                      color: '#2f2f2f',
                    }}
                  >
                    Shipping
                  </h5>

                  {formattedShippedDate ? (
                    <p
                      style={{
                        marginBottom: '0',
                        color: '#8c8c8c',
                        fontSize: '14px',
                      }}
                    >
                      Shipped On: {formattedShippedDate}
                    </p>
                  ) : (
                    <p
                      style={{
                        marginBottom: '0',
                        color: '#8c8c8c',
                        fontSize: '14px',
                      }}
                    >
                      Not shipped yet
                    </p>
                  )}
                </div>
              </div>

              <hr />
            </div>

            <h4 className="my-4">Order Items:</h4>

            <div className="">
              <div className="cartWrapper mt-4">
                <div className="table-responsive" style={{ overflowX: 'auto' }}>
                  <table className="table">
                    <thead>
                      <tr>
                        <th style={{ minWidth: '120px' }}>Product</th>
                        <th style={{ minWidth: '250px' }}>Product id</th>
                        <th style={{ minWidth: '200px' }}>Product Name</th>
                        <th style={{ minWidth: '150px' }}>Total Products</th>
                        <th style={{ minWidth: '150px' }}>Price</th>
                      </tr>
                    </thead>
                    {orderDatail.orderItems &&
                      orderDatail.orderItems.map(item => (
                        <tbody key={item.id}>
                          <tr>
                            <td>
                              <div className="d-flex align-items-center">
                                <div className="img">
                                  <img
                                    src={item.image}
                                    alt={item.name}
                                    style={{ height: '75px', width: '75px' }}
                                  />
                                </div>
                              </div>
                            </td>
                            <td>
                              <Link to={`/products/${item.product?._id}`}>
                                <span className="text-g">
                                  {item?.product?.clocreProductId || '-'}
                                </span>
                              </Link>
                            </td>

                            <td>
                              <Link
                                to={`/products/${item.product?._id}`}
                                style={{ color: 'black', fontSize: '16px' }}
                              >
                                <span style={{ color: '#8c8c8c' }}>
                                  {item.name}
                                </span>
                              </Link>
                            </td>

                            <td>
                              <span style={{ color: '#8c8c8c' }}>
                                {item.quantity} Piece(s)
                              </span>
                            </td>

                            <td>
                              <span style={{ color: '#8c8c8c' }}>
                                ₹{item.price}
                              </span>
                            </td>
                          </tr>
                        </tbody>
                      ))}
                  </table>
                </div>
              </div>
              <br />
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
